<template>
	<section class="marketing-section bg-color-bg-tertiary">
		<div class="container">
			<h2 class="heading-4 text-align-center mb-300-md mb-200-smo">Ways to invest</h2>
			<div class="tiles-wrapper">
				<article class="display-flex flex-direction-column bg-color-white p-200 mb-300-smo">
					<h3 class="ff-ivar-display beta font-weight-lighter line-height-100">
						Personal investment account
					</h3>
					<p class="delta mb-150 line-height-150">
						Open a standard account and build a portfolio of alternative investments.
					</p>
					<BaseCtaLink
						classes="mt-auto body-lg"
						:link="{ router: 'get-started', text: 'Open your account' }"
						icon="arrow"
					/>
				</article>
				<article class="display-flex flex-direction-column bg-color-white p-200 mb-300-smo">
					<h3 class="ff-ivar-display beta font-weight-lighter line-height-100"> Tax-advantaged investing </h3>
					<p class="delta mb-150 line-height-150">
						Roll over an existing retirement account or open a new Traditional or Roth IRA.
					</p>
					<BaseCtaLink
						classes="mt-auto body-lg"
						:link="{ router: 'get-started', text: 'Invest in your retirement' }"
						icon="arrow"
					/>
				</article>
				<article class="display-flex flex-direction-column bg-color-white p-200">
					<h3 class="ff-ivar-display beta font-weight-lighter line-height-100"> Through your advisor </h3>
					<p class="delta mb-150 line-height-150">
						Work with an RIA? We can give them access to invest on your behalf.
					</p>
					<BaseCtaLink
						classes="mt-auto body-lg"
						:link="{ router: 'advisor-landing', text: 'Learn more' }"
						icon="arrow"
					/>
				</article>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

.tiles-wrapper {
	display: grid;

	@include respond-to(mdo) {
		gap: 1.5rem;
	}

	@include respond-to(md) {
		grid-auto-flow: column;
		grid-auto-columns: 1fr;
	}

	@include respond-to(lg) {
		gap: 3rem;
	}
}
</style>
